import { forwardRef } from 'react';

import { Progress } from '../progress/progress';
import type { ProgressBarPropsInterface } from './types/progress-bar.types';

/**
 * Shorthand Progress component
 *
 * @related ['Progress']
 * @since 10.0.0
 */
export const ProgressBar = forwardRef<HTMLDivElement, ProgressBarPropsInterface>(
  (props: ProgressBarPropsInterface, forwardedRef) => {
    const { minValue = 0, maxValue = 100, size = 'sm', stepperOffset, value, ...rest } = props;

    return (
      <Progress.Root
        minValue={minValue}
        maxValue={maxValue}
        size={size}
        stepperOffset={stepperOffset}
        value={value}
      >
        <Progress.Bar {...rest} ref={forwardedRef}>
          <Progress.Range />
          <Progress.Track />
        </Progress.Bar>
      </Progress.Root>
    );
  },
);

ProgressBar.displayName = 'ProgressBar';
